import React from 'react'
import useAxios from '../utils/useAxios'
import { useState, useEffect } from 'react'

function AddCategory() {
    let api = useAxios()
    const [companies, setCompanies] = useState([])

    useEffect(() => {
        getCompanies()
    }, [])

    let getCompanies = async () => {
        let response = await api.get('/api/companies/')
        if (response.status === 200) {
            setCompanies(response.data)
        }
    }


    let postCategory = async (e) => {
        // e.preventDefault()
        let response = await api.post('/api/add-category/', {
            'name': e.target.name.value,
            'company': e.target.company.value,
        })

        if (response.status === 200) {
            alert("Company Created Successfully")
        } else {
            alert("There was some errors please try again")
        }


    }

  return (
    <div>
        <div className="modal fade" id="categoryModal" tabIndex="-1" aria-labelledby="categoryModal" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">New Invoice</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <form onSubmit={postCategory}>
                <div className="mb-3">
                    <label htmlFor='name' className="col-form-label">Invoice name</label>
                    <input type="text" className="form-control" id="name" name='name' required/>
                </div>
                <div className="mb-3">
                    <label htmlFor='company' className="col-form-label">Category's Company</label>
                    <select className="form-select" aria-label="Default select example" name='company'>
                        {companies.map(company => (
                            <option key={company.id} value={company.id}>{company.name}</option>
                        ))}
                    </select>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <input type="submit" className="btn btn-success" value="Add" data-bs-dismiss="modal" />
                </div>
                </form>
            </div>

            </div>
        </div>
        </div>
    </div>
  )
}

export default AddCategory